/** @format */
import { HeaderCheckBoxSelectListElement } from './listTableHeader/HeaderCheckBoxSelectList';

const _ = require('underscore');

export const numberStateIdMapInt = {
    IN_PROGRESS: 1,
    FINISH: 2,
    ERROR: 3,
};

export const numberStateIdMapI18n = {
    IN_PROGRESS: 'prov:state.in_progress',
    FINISH: 'prov:state.finish',
    ERROR: 'prov:state.error',
};

export class ApiOperationStateHelper {
    static getStateName(stateApiId: number): string {
        switch (stateApiId) {
            case numberStateIdMapInt.ERROR:
                return numberStateIdMapI18n.ERROR;
            case numberStateIdMapInt.IN_PROGRESS:
                return numberStateIdMapI18n.IN_PROGRESS;
            case numberStateIdMapInt.FINISH:
                return numberStateIdMapI18n.FINISH;
            default:
                return '';
        }
    }

    getStatus = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { value: numberStateIdMapInt.IN_PROGRESS, name: numberStateIdMapI18n.IN_PROGRESS },
            { value: numberStateIdMapInt.FINISH, name: numberStateIdMapI18n.FINISH },
            { value: numberStateIdMapInt.ERROR, name: numberStateIdMapI18n.ERROR },
        ];
    };
}
